import { createFeatureSelector, createSelector } from '@ngrx/store';
import { ReportsState } from '@core/reports/reports.interfaces';

export const selectReportsState = createFeatureSelector<ReportsState>('reports');

export const getReportsLoadingState = createSelector(selectReportsState, state => state.loading);
export const getReportsErrorState = createSelector(selectReportsState, state => state.error);
